module.exports = __webpack_public_path__ + "img/help.7119986a.svg";